export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_70f7f5de-b2e2-4e23-bc7a-a4e73e186ba8/artifacts/5s1m4umq_WhatsApp%20Image%202026-05-28%20at%2022.56.34.jpeg";

// Original real photos for the smaller packs
export const MENU_IMG_10 =
  "https://customer-assets.emergentagent.com/job_nibs-southeast/artifacts/96pdtg9m_520E0E6D-3B8A-4F2D-8A5C-C56B119FC112.JPG";
export const MENU_IMG_20 =
  "https://customer-assets.emergentagent.com/job_nibs-southeast/artifacts/vcjnupgo_677D37F6-7D41-4150-81BF-7A05CFF81306.JPG";
export const MENU_IMG_30 = "/menu/nibs-30.png";

// AI-generated cinematic shots for the big trays
export const MENU_IMG_55 = "/menu/nibs-55.png";
export const MENU_IMG_45 = "/menu/nibs-45.png";

// Kept for any legacy imports (social proof, etc.)
export const MENU_IMG_SMALL = MENU_IMG_10;
export const MENU_IMG_LARGE = MENU_IMG_55;

export const SMOKE_IMG =
  "https://static.prod-images.emergentagent.com/jobs/70f7f5de-b2e2-4e23-bc7a-a4e73e186ba8/images/4f6dde65985bfb841e55cf8f09008e5b289ceda243645af1fbee53f118fa37d4.png";

export const SOCIAL_IMAGES = [MENU_IMG_55, MENU_IMG_10, MENU_IMG_45, MENU_IMG_20];

export function imageForPack(packId) {
  switch (packId) {
    case "nibs-10": return MENU_IMG_10;
    case "nibs-20": return MENU_IMG_20;
    case "nibs-30": return MENU_IMG_30;
    case "nibs-45": return MENU_IMG_45;
    case "nibs-55": return MENU_IMG_55;
    default:        return MENU_IMG_30;
  }
}
